import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useSignUpPageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: signUpPageContentJson {
        header {
          description
          email_placeholder
          email_label
          form_headline {
            html
          }
          full_name_label
          full_name_placeholder
          headline {
            html
          }
          industry_label
          industry_placeholder
          message_label
          message_placeholder
          back_button_label
          website_label
          website_placeholder
          form_button_label
          industry_select_options {
            label
            value
          }
          error_message
        }
      }
      de: deSignUpPageContentJson {
        header {
          description
          email_placeholder
          email_label
          form_headline {
            html
          }
          full_name_label
          full_name_placeholder
          headline {
            html
          }
          industry_label
          industry_placeholder
          message_label
          message_placeholder
          back_button_label
          website_label
          website_placeholder
          form_button_label
          industry_select_options {
            label
            value
          }
          error_message
        }
      }
    }
  `);

  return data[locale];
};
